'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'motorcycle';
var width = 640;
var height = 512;
var aliases = [127949];
var unicode = 'f21c';
var svgPathData = 'M264 32l-8 0 0 16 8 0 83.1 0 20.2 39.4-111.6 79-30.3-18.9c-20.3-12.7-43.9-19.5-67.8-19.5L40 128c-4.4 0-8 3.6-8 8l0 48 0 8 8 0 71.8 0c94.2 0 171.7 74.2 175.8 168.4l.3 8 .3 7.7 7.7 0 48 0 8 0 0-8 0-16c0-59.2 32.2-110.9 79.9-138.6L446.6 242C409.1 264.3 384 305.2 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-18.2 0-35.5 3.8-51.2 10.6L406.1 128l97.9 0 8 0 0-8 0-80 0-8-8 0-56 0-2.5 0-2.1 1.5L380.5 78 359.1 36.3 356.9 32 352 32l-88 0zm-3.4 150.5l114-80.8 50 97.4C371.7 229.5 336 286.6 336 352l0 8-32.3 0 0-.3C299.2 257 214.6 176 111.8 176L48 176l0-32 109.6 0c21 0 41.6 5.9 59.4 17l34.8 21.8 4.5 2.8 4.3-3.1zM496 112l-98.1 0L387.9 92.4 450.5 48 496 48l0 64zM453.9 256.2l51 99.4 3.7 7.1 14.2-7.3-3.6-7.1-51-99.4c13.5-5.7 28.3-8.9 43.9-8.9c61.9 0 112 50.1 112 112s-50.1 112-112 112s-112-50.1-112-112c0-40.6 21.6-76.1 53.9-95.8zM239.7 344l-48.2 0c-3.9-31.6-30.9-56-63.5-56c-35.3 0-64 28.7-64 64s28.7 64 64 64c32.6 0 59.6-24.4 63.5-56l48.2 0c-4.1 58.1-52.6 104-111.7 104C66.1 464 16 413.9 16 352s50.1-112 112-112c59.2 0 107.6 45.9 111.7 104zm-64.4 0L128 344l-8 0 0 16 8 0 47.3 0c-3.8 22.7-23.6 40-47.3 40c-26.5 0-48-21.5-48-48s21.5-48 48-48c23.8 0 43.5 17.3 47.3 40zM128 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMotorcycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;